import { useEffect, useRef, HTMLProps } from 'react';

export const IndeterminateCheckbox = ({
	/* 
		Checkbox inputs can only have two states: checked or unchecked. They can have any value, but they either submit that value (checked) or don’t (unchecked) with a form submission. The default is unchecked.
		However visually, there are actually three states a checkbox can be in: checked, unchecked, or indeterminate.
		Each checkbox may have child checkboxes. If all those children are checked, it may be checked. If none are checked, it is unchecked. If some of them are checked, then it’s in an indeterminate state (in this case symbolically meaning “partially” checked).
		You can’t make a checkbox indeterminate through HTML. There is no indeterminate attribute. It is a property of checkboxes though, which you can change via JavaScript.

		https://css-tricks.com/indeterminate-checkboxes/
	*/

	indeterminate,
	className = '',
	...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
	const ref = useRef<HTMLInputElement>(null!);

	useEffect(() => {
		if (typeof indeterminate === 'boolean') {
			ref.current.indeterminate = !rest.checked && indeterminate;
		}
	}, [ref, indeterminate, rest.checked]);

	return (
		<input
			type='checkbox'
			data-test-id='tableCheckBox-select'
			ref={ref}
			className={className + ' cursor-pointer text-success'}
			{...rest}
		/>
	);
};
